import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-eqbd-approval-dialog",
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule],
  templateUrl: "./eqbd-approval-dialog.component.html",
  styleUrl: "./eqbd-approval-dialog.component.scss"
})
export class EqbdApprovalDialogComponent {
  eqbdToggleValue = 2; // 2 = YES, 0 = NO

  constructor(
    private dialogRef: MatDialogRef<EqbdApprovalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  onApprove(): void {
    this.dialogRef.close({
      approved: true,
      isEQBDAvailabe: Number(this.eqbdToggleValue) === 2 ? 1 : 0
    });
  }

  onCancel(): void {
    this.dialogRef.close({ approved: false });
  }

  getToggleColor(value: number): string {
    const val = Number(value);
    if (isNaN(val)) return "#ccc";
    switch (val) {
      case 0: return "#FFFAE5";
      case 2: return "#FFFAE5";
      default: return "#ccc";
    }
  }

  getToggleBorder(value: number): string {
    const val = Number(value);
    if (isNaN(val)) return "#ccc";
    switch (val) {
      case 0: return "1px solid #A99333";
      case 2: return "1px solid #A99333";
      default: return "#ccc";
    }
  }
}
